var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeCompany)?_c('div',{key:_vm.activeCompany._id},[_c('OvationSurveyModal',{ref:"ovationSurveyModal"}),_c('DashboardHeader'),(_vm.initialized)?_c('DashboardBody',{key:_vm.selectRefreshKey}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }